import { render, staticRenderFns } from "./PopupHeader.vue?vue&type=template&id=28f7755c&scoped=true"
import script from "./PopupHeader.vue?vue&type=script&lang=js"
export * from "./PopupHeader.vue?vue&type=script&lang=js"
import style0 from "./PopupHeader.vue?vue&type=style&index=0&id=28f7755c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7755c",
  null
  
)

export default component.exports